import React from 'react';

import LastListPosts from '../../components/LastListPosts/LastListPosts';
import InterestingLinks from '../../components/InterestingLinks/InterestingLinks'

const aside = (props) => {
  return (
    <div className="col-start-1 col-end-7 mt-5 lg:col-start-5 lg:col-end-7 lg:mt-0 lg:ml-5">
      <LastListPosts />
      <InterestingLinks />
    </div>
  )
}

export default aside;
